import React, {memo} from "react"
import connect from "./connect"

import SimpleAutoComplete from "./simple/AutoComplete"
import SimpleRecentSearches from "./simple/RecentSearches"
import SimpleModal from "./simple/Modal"

import EnrichedAutoComplete from "./enriched/AutoComplete"
import EnrichedRecentSearches from "./enriched/RecentSearches"
import EnrichedModal from "./enriched/Modal"

type SupportedFeatures = {
    simpleSearchEnabled: boolean
    enrichedSearchEnabled: boolean
}

export const GetAutoCompleteComponent = memo(({simpleSearchEnabled, enrichedSearchEnabled}: SupportedFeatures) => {
    if (enrichedSearchEnabled) return <EnrichedAutoComplete />
    if (simpleSearchEnabled) return <SimpleAutoComplete />
    return <SimpleAutoComplete />
})
GetAutoCompleteComponent.displayName = "GetAutoCompleteComponent"

export const GetRecentSearchesComponent = memo(({simpleSearchEnabled, enrichedSearchEnabled}: SupportedFeatures) => {
    if (enrichedSearchEnabled) return <EnrichedRecentSearches />
    if (simpleSearchEnabled) return <SimpleRecentSearches />
    return <SimpleRecentSearches />
})
GetRecentSearchesComponent.displayName = "GetRecentSearchesComponent"

interface ModalComponentProps {
    simpleSearchEnabled: boolean
    enrichedSearchEnabled: boolean
    open: boolean
    closeText: string
    handleClose: () => void
    children: JSX.Element
    hideBackdrop: boolean | null
}

export const GetModalComponent = memo(
    ({
        simpleSearchEnabled,
        enrichedSearchEnabled,
        open,
        handleClose,
        children,
        closeText,
        hideBackdrop,
    }: ModalComponentProps) => {
        if (enrichedSearchEnabled) {
            return (
                <EnrichedModal open={open} handleClose={handleClose} closeText={closeText} hideBackdrop={hideBackdrop}>
                    {children}
                </EnrichedModal>
            )
        }
        if (simpleSearchEnabled) {
            return (
                <SimpleModal open={open} handleClose={handleClose} closeText={closeText}>
                    {children}
                </SimpleModal>
            )
        }
        return null
    },
)
GetModalComponent.displayName = "GetModalComponent"

export const AutoCompleteComponent = connect(GetAutoCompleteComponent)
export const RecentSearchesComponent = connect(GetRecentSearchesComponent)
export const ModalComponent = connect(GetModalComponent)
